import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const Expense_CategoryTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [Data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchbranchData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchFormData(
        "list-expense-category",
        formData,
        "POST"
      );

      if (result) {
        const data = result.data || [];
        setData(data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      Swal.fire("Error", "Failed to load data.", "error");
    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    try {
      const formData = new FormData();
      formData.append("id", Id);
      formData.append("userId", userId);
      formData.append("moduleId", M_id);

      const result = await fetchFormData(
        `expense-category-list/toggle-status/${Id}`,
        formData,
        "POST"
      );

      if (result && result.code === 200) {
        await fetchbranchData();

        const updatedStatus = Number(
          result?.updated_status ?? result?.user?.status ?? -1
        );

        const statusText =
          updatedStatus === 1
            ? "Active"
            : updatedStatus === 0
            ? "Deactive"
            : "Unknown";

        topTost({
          title: `Status updated successfully: ${statusText}`,
          icon: "success",
        });
      } else {
        topTost({
          title: result?.message || "Failed to toggle status",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Toggle error:", error);
      topTost({
        title: "An error occurred while toggling status",
        icon: "error",
      });
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const isActive = String(row.original.status) === "1"; // Handle both string/number

              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(
                          `/master/edit-expense-category/${id}?id=${M_id}`
                        )
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}

                  {permission?.pf_status === 1 &&
                    (isActive ? (
                      <MdThumbUp
                        title="Activate"
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        title="Deactivate"
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "expense_category",
      header: "Expense Category",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // Can be "1" or "0"
        const isActive = String(val) === "1";

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
          borderRadius: "4px",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchbranchData();
  }, []);
  return (
    <>
      <Table data={Data} columns={columns} />
    </>
  );
};

export default Expense_CategoryTable;
